<script setup lang="ts">
const article = inject(keys.currentArticle)
</script>

<template>
  <figure class="mb-8 w-full">
    <CrystallizeImage
      :image="article?.cover"
      img-class="h-[clamp(20rem,40vw,45rem)] w-full object-cover object-top"
    />
    <div
      class="relative -mt-4 bg-(--background) text-(--foreground) md:px-24"
      :class="[article?.colorTheme, {
        'mx-auto bg-transparent md:-mt-48': article?.variant !== 'feature',
      }]"
    >
      <UArticleContainer
        class="relative bg-(--background) py-8 md:pt-18 md:pb-14"
        :class="{ 'px-8 md:px-24': article?.variant !== 'feature' }"
      >
        <template v-if="article?.contentType === 'podcast'">
          <CrystallizeImage
            :image="article.thumbnailImage"
            class="absolute -top-28 right-legacy-s sm:-top-48 md:right-legacy-m"
            img-class="w-36 rounded-md border-2 border-white sm:w-64"
          />
          <UiArticlesTheme class="mb-4" />
        </template>
        <UiArticlesTitle class="mb-8 text-5xl md:text-6xl" />
        <div class="text-lg leading-10! md:text-2xl md:leading-8!" v-html="article?.intro" />
        <div
          v-if="
            article?.variant === 'feature'
              && 'description' in article
              && article.description
          "
          class="pt-8 text-xl [&_a]:text-inherit"
          v-html="article.description"
        />
        <UiArticlesByline class="mt-10 flex gap-4 text-white" />
      </UArticleContainer>
    </div>
  </figure>
</template>
